import { useParams } from 'react-router-dom'
import DocLayout from '../components/docs/DocLayout'
import PatternExample from '../components/docs/PatternExamples'
import SourceLinks from '../components/docs/SourceLinks'
import CopyButton from '../components/docs/CopyButton'
import Icon from '../components/docs/Icon'
import { patterns } from '../content/system'
import NotFoundPage from './NotFoundPage'
import Cased from '@/components/ui/Cased'
import Pager from '../components/docs/Pager'
export default function PatternDetailPage() {
  const { slug } = useParams()
  const pattern = patterns.find((item) => item.id === slug)
  // The patterns page's order, so Previous and Next walk the whole set.
  const index = patterns.findIndex((item) => item.id === slug)
  const previous = index > 0 ? patterns[index - 1] : undefined
  const next = index >= 0 && index < patterns.length - 1 ? patterns[index + 1] : undefined
  if (!pattern) return <NotFoundPage />
  return (
    <DocLayout section={{ label: 'Patterns', to: '/patterns' }}
      eyebrow={`Patterns / ${pattern.category}`}
      title={pattern.title}
      intro={pattern.summary}
      wide
    >
      <aside className="doc-callout">
        <p className="mds-eyebrow">When to use</p>
        <p>{pattern.useWhen}</p>
      </aside>
      <section className="doc-section">
        <div className="pat-section-head">
          <h2><Cased>See it in action</Cased></h2>
          <span className="mds-tag">
            <span className="mds-tag__dot pat-dot--success" aria-hidden="true" />
            Interactive example
          </span>
        </div>
        <p className="mds-muted">
          Try the controls. The illustrative data and changes stay in this page.
        </p>
        <div className="pat-live" key={pattern.id}>
          <PatternExample id={pattern.id} />
        </div>
      </section>
      <div className="pat-guidance">
        <section className="doc-section">
          <h2><Cased>Anatomy</Cased></h2>
          <ol className="pat-anatomy">
            {pattern.anatomy.map((item, index) => (
              <li key={item}>
                <span>{String(index + 1).padStart(2, '0')}</span>
                {item}
              </li>
            ))}
          </ol>
        </section>
        <section className="doc-section">
          <h2><Cased>Implementation rules</Cased></h2>
          <ul className="pat-checks">
            {pattern.requirements.map((item) => (
              <li key={item}>
                <Icon name="check" size={17} />
                {item}
              </li>
            ))}
          </ul>
        </section>
      </div>
      <section className="doc-section">
        <h2><Cased>Acceptance checks</Cased></h2>
        <p>
          Verify the behavior in context, with a keyboard and at narrow widths.
        </p>
        <ul className="pat-checks">
          {pattern.acceptance.map((item) => (
            <li key={item}>
              <Icon name="check" size={17} />
              {item}
            </li>
          ))}
        </ul>
      </section>
      <section className="doc-section">
        <div className="pat-section-head">
          <h2><Cased>Pattern contract</Cased></h2>
          <CopyButton
            text={JSON.stringify(pattern, null, 2)}
            label="Copy pattern JSON"
          />
        </div>
        <details className="doc-details">
          <summary>Read the machine-readable definition</summary>
          <pre className="mds-code" tabIndex={0}>
            <code>{JSON.stringify(pattern, null, 2)}</code>
          </pre>
        </details>
      </section>
      <Pager
        label="Patterns"
        previous={previous && { to: `/patterns/${previous.id}`, title: previous.title }}
        next={next && { to: `/patterns/${next.id}`, title: next.title }}
      />
      <SourceLinks ids={pattern.sourceIds} />
    </DocLayout>
  )
}
